import React, { useMemo } from 'react';
import { JsonLd } from '@nerdwallet/json-ld';
import PropTypes from 'prop-types';

const VideoJsonLd = ({ contentDetails, snippet, player }) => {
  const jsonLd = useMemo(() => {
    const { thumbnails, description, title, publishedAt } = snippet;
    return {
      '@type': 'VideoObject',
      name: title,
      description,
      thumbnailUrl: [
        thumbnails?.standard?.url,
        thumbnails?.default?.url,
        thumbnails?.high?.url,
        thumbnails?.medium?.url,
        thumbnails?.maxres?.url,
      ],
      uploadDate: publishedAt,
      duration: contentDetails?.duration,
      embedUrl: player?.embedHtml,
    };
  }, [contentDetails, snippet, player]);

  if (!jsonLd) return null;

  return <JsonLd>{jsonLd}</JsonLd>;
};

VideoJsonLd.propTypes = {
  contentDetails: PropTypes.object,
  snippet: PropTypes.object,
  player: PropTypes.object,
};

VideoJsonLd.defaultProps = {
  contentDetails: PropTypes.object,
  snippet: PropTypes.object,
  player: PropTypes.object,
};

export default VideoJsonLd;
